import React, { useContext, useEffect, useState } from 'react';
import { Question } from '../../../../hoc/context/product/context-model';
import { window } from 'browser-monads';
import {
	enrollmentContext,
	AnswerValueProp,
} from '../../../../hoc/context/enrollment/enrollment-context';
import {
	Identifiers,
	EventKeys,
	EventCategory,
} from '../../../../../services/ga';
import { QuestionInputFactory } from './input';
import context from '../../../../hoc/context/product/context';
import { getCustomKeyValues } from '../../../../../services/analytics-helper';
import AnalyticsFactory from '../../../../../services/analytics-factory';

interface QuestionViewComponentProps {
	question: Question;
	next: Function;
}

function QuestionViewComponent({ question, next }: QuestionViewComponentProps) {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);
	const [value, setValue] = useState<Date | AnswerValueProp | undefined>(
		undefined
	);

	useEffect(() => {
		const customKeyValues = getCustomKeyValues(
			Identifiers.PatientEligibility,
			'',
			question,
			ctxt,
			enrollmentCtxt
		);
		if (
			window?.location?.href.indexOf('/wizard/savings/1') !== -1 &&
			customKeyValues[EventKeys.PatientEligibility]
		) {
			const analytics = AnalyticsFactory.createAnalytics('ga');
			analytics.sendEvent({
				[EventKeys.EventCategory]: EventCategory.SignUp,
				[EventKeys.EventLabel]: customKeyValues[EventKeys.PatientEligibility],
				...customKeyValues,
			});
		}
	}, [question]);

	useEffect(() => {
		setValue(undefined);

		const answer = enrollmentCtxt.getQuestion(question.id);

		if (answer) {
			setValue(answer.answer);
		}
	}, [enrollmentCtxt, question]);

	const answerQuestion = (
		answerValue: Date | AnswerValueProp,
		emitEvent: boolean = true
	) => {
		setValue(answerValue);
		enrollmentCtxt.answerQuestion({
			id: question.id,
			title: question.title as string,
			answer: answerValue,
			type: question.type as 'boolean' | 'date' | 'choice',
		});
		if (emitEvent) {
			next();
		}
	};


	return (
			<QuestionInputFactory
				question={question}
				answer={value as string}
				answerQuestion={answerQuestion}/>
	);
}

export default QuestionViewComponent;
